import { HttpHeaders } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';

// Built per request rather than cached in a field, so a token renewed between requests is picked
// up. Note the token is read when the request is built, not when it is subscribed to.
export function bearerTokenHeaders(oauthService: OAuthService): HttpHeaders {
  return new HttpHeaders({
    Authorization: `Bearer ${oauthService.getAccessToken()}`,
  });
}
